import * as React from 'react';
import { useRef } from 'react'
import 'react-multi-carousel/lib/styles.css';
import { useEffect, useState } from "react";
import { Box, Card, CardActionArea, Input } from '@mui/material';
import { gold, white } from '../../../../../getLPTheme';
import { useParams } from 'react-router-dom';


const icons: Record<any, { icon: string, width: number }> = {
  club: {
    icon: '../../icons-svg/club.svg',
    width: 100,
  },
  hotel: {
    icon: '../../icons-svg/hotel3.svg',
    width: 100,
  },
  comercio: {
    icon: '../../icons-svg/proshop.svg',
    width: 100,
  },
  restaurant: {
    icon: '../../icons-svg/restaurant2.svg',
    width: 100,
  },
};

export default function MapInit({items}) {

  let [mapa, setMap] = useState<google.maps.Map>()
  const ref = useRef<HTMLDivElement>()

  const params = useParams();
  const searchedRowData = items.find((row) => row.pointId === params.mid);

  const [formData, setFormData] = React.useState({
    pointId: searchedRowData.pointId,
    name: searchedRowData.name,
    typeMarker: searchedRowData.typeMarker,
    address: searchedRowData.address,
    country: searchedRowData.country,
    state: searchedRowData.state,
    locate: searchedRowData.locate,
    contact: searchedRowData.contact,
    url: searchedRowData.url,
    coordinates: searchedRowData.coordinates,
    discount: searchedRowData.discount,
  });

  let positionLat = Number.parseFloat(formData.coordinates.slice(0,formData.coordinates.indexOf(",")))
  let positionLng = Number.parseFloat(formData.coordinates.slice(((formData.coordinates.indexOf(","))+1),formData.coordinates.length))
  const position = { lat: positionLat, lng: positionLng };
    
  function widthScreen () {
      const widthScreen = document.body.clientWidth
      if (widthScreen < 500) { let widthMap = "300px"
          return widthMap
      } else {
        let widthMap = "500px"
        return widthMap
      }
    }
  
  function heightScreen () {
    const widthScreen = document.body.clientWidth
    if (widthScreen < 500) { let heightMap = "300px"
        return heightMap
    } else {
      let heightMap = "500px"
      return heightMap
    }
  }

  const InitMaptest = async () => {

    useEffect(()=>{
      if(ref.current && !mapa){
        setMap(new google.maps.Map(document.getElementById('map') as HTMLElement, {
          center: position,
          zoom: 13,
          mapId: 'b43fd4b4ec044b83 ',
        }))
      }
    }, [mapa])


    const marcadores = items

    const {AdvancedMarkerElement}  = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;


        let markerSvg = document.createElement('img');
        markerSvg.src = icons[formData.typeMarker].icon
        markerSvg.width = 70;

        let collisionBehavior = google.maps.CollisionBehavior.REQUIRED;  // Si se superponen no desaparecen

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: mapa,
          position: position,
          title: formData.pointId,
          content: markerSvg,
          collisionBehavior: collisionBehavior,
        });

        marker.addListener("click", () => {
          let infowindow = new google.maps.InfoWindow({content: `<div><b>${formData.name}</b>, ${formData.address}</div><br><div>${formData.country}, ${formData.state}, ${formData.locate}</div> <div><a href="https://maps.google.com/maps?ll=${positionLat},${positionLng}&z=15" target="_blank">Ver en Google Maps</a></div>`,ariaLabel: formData.name, disableAutoPan: true,})
          infowindow.open({
            anchor: marker,
            map: mapa,
          });        
        });
        return marker;

    };

    InitMaptest();
    
    return (
      <>
        <Box sx={{ width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
          <Box  sx={{ width:{xs:"80%", sm:"50%", md:"50%"}, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
            <Box>
              <Card sx={{p:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
                  <Box id="map" ref={ref as any} style={{ width: widthScreen(), minHeight:heightScreen()}}></Box>
              </Card>
            </Box>
          </Box>
        </Box>
      </>
      )
  }